<template>
  <div id="sskProductDetailPage">
    <div class="mainContent">
      <header>
        <div class="topBackground">
          <img class="head-img" src="../../../../static/images/product/ssk/top.png" alt="" >
        </div>
      </header>
      <section>
        <div class="headline">
          <div id="nav" class="main-info">
            <div class="info-tit flex" data-tips="0">
              <div class="tit-item active" data-tips="0">
                <a class="tit flex" href="javascript:;" >
                  <div class="tit-wrap">
                    保障计划
                  </div>
                </a>
              </div>
              <div class="tit-item" data-tips="1">
                <a class="tit flex" href="javascript:;" >
                  <div class="tit-wrap" >
                    产品特色
                  </div>
                </a>
              </div>
              <div class="tit-item" data-tips="2">
                <a class="tit flex" href="javascript:;">
                  <div class="tit-wrap">
                    理赔案例
                  </div>
                </a>
              </div>
              <div class="tit-item" data-tips="3">
                <a class="tit flex" href="javascript:;">
                  <div class="tit-wrap">
                    常见问题
                  </div>
                </a>
              </div>
            </div>
            <div class="line">
              <div class="sliding">
                <div class="slidingBlock"></div>
              </div>
            </div>
          </div>
        </div>
        <div id="detailsList" class="detailsList">
          <div class="blankBlock" v-if="upState"></div>
          <img id="detail-content1" src="../../../../static/images/product/ssk/details-1.png" alt="" >
          <img id="detail-content2" src="../../../../static/images/product/ssk/details-2.png" alt="" >
          <img id="detail-content3" src="../../../../static/images/product/ssk/details-3.png" alt="" >
          <img id="detail-content4" src="../../../../static/images/product/ssk/details-4.png" alt="" >
          <img id="detail-content5" src="../../../../static/images/product/ssk/details-5.png" alt="" >
        </div>
      </section>
      <footer>
        <div class="clause flex-start">
          <span class="check_box whetherAgree">
            <img class="checkbox" src="../../../../static/images/product/ssk/checkbox_no.png" v-if="checked == false">
            <img class="checkbox" src="../../../../static/images/product/ssk/checkbox_yes.png" v-if="checked == true">
          </span>
          <span>
            <p style="display: inline-block">我已认真阅读并确认</p>
            <span class="clauseUnit" @click="chooseRead(1)">《投保须知》</span>
            <span class="clauseUnit" @click="chooseRead(2)">《投保细则》</span>
            <span class="clauseUnit" @click="chooseRead(3)">《理赔细则》</span>
            <span class="clauseUnit" @click="chooseRead(4)">《授权声明》</span>
            <span class="clauseUnit" @click="chooseRead(5)">《保险条款》</span>
            <span class="clauseUnit" @click="chooseRead(6)">《用户协议》</span>
            <span class="clauseUnit" @click="chooseRead(7)">《用户隐私政策》</span>
          </span>
        </div>
        <div class="footerUnit">
          <a class="kefu" href="https://work.weixin.qq.com/kfid/kfce82ed2eaaae38c7f">
            <div class="kefu">
              <div class="kefuImg"></div>
              <div class="kefuText">客服</div>
            </div>
          </a>
          <div class="submit" @click="getInterest">立即参保</div>
        </div>
      </footer>
    </div>

    <!-- 手机验证弹窗 -->
    <el-dialog
      :visible.sync="claimDialog"
      width="86%"
      :modal="true"
      :modal-append-to-body="false"
      :show-close="false"
      center>
      <div class="head">
        <div class="title">温馨提示</div>
        <div class="title-hint">请先校验手机号码再领取权益哦~</div>
      </div>
      <div class="check">
        <el-input type="number" v-model="account" onkeyup="value=value.replace(/[^\d]/g,'')" oninput="if(value.length>11)value=value.slice(0,11)" placeholder="请输入手机号码" class="account"></el-input>
        <el-button @click="receiveCheck" class="receive">立即领取</el-button>
        <div class="cueWords">
          <div class="prompt">
            <span :class="promptStates"></span>
            <span class="errorPrompt" v-html="errorPrompt">{{errorPrompt}}</span>
          </div>
          <div class="contact">如有疑问请致电：<a href="tel:02082513114" >020-82513114</a></div>
        </div>
      </div>
    </el-dialog>

    <!-- 协议弹窗 -->
    <div v-if="checkedRead" class="readDialog">
      <div class="readDialogView">
        <div class="readDialog-header">
          您需要阅读以下内容
          <div class="closeDialog" @click="closeDialog"></div>
        </div>
        <div>
          <div class="tabList">
            <div class="tabUnit selectTab" @click="tabUnit(1, false)">《投保须知》</div>
            <div class="tabUnit" @click="tabUnit(2, false)">《投保细则》</div>
            <div class="tabUnit" @click="tabUnit(3, false)">《理赔细则》</div>
            <div class="tabUnit" @click="tabUnit(4, false)">《授权声明》</div>
            <div class="tabUnit" @click="tabUnit(5, false)">《保险条款》</div>
            <div class="tabUnit" @click="tabUnit(6, false)">《用户协议》</div>
            <div class="tabUnit" @click="tabUnit(7, false)">《用户隐私政策》</div>
            <div class="line">
              <div class="sliding">
                <div class="slidingBlock"></div>
              </div>
            </div>
          </div>
          <div class="agreementContent">
            <img class="agreement selectAgreement" src="https://pic.xiaobaibao.com/clause/2022/11/875f6dc57bcf4df58bffc8b0cc5587ca.png" alt="" data-value="1" >
            <img class="agreement" src="https://pic.xiaobaibao.com/clause/2022/11/d8ae274f23004dfba444d776c3422d62.png" alt="" data-value="2" >
            <img class="agreement" src="https://pic.xiaobaibao.com/clause/2022/11/ace40092e880422fbd2110586fae6d2c.png" alt="" data-value="3">
            <img class="agreement" src="https://pic.xiaobaibao.com/clause/2022/11/09f2219c1c8340acbf630c26e646c81c.png" alt="" data-value="4">
            <img class="agreement" src="https://pic.xiaobaibao.com/clause/2022/11/a2dd5513e87549feb8e79f8804092762.png" alt="" data-value="5">
            <img class="agreement" src="https://pic.xiaobaibao.com/clause/2022/11/22469315218c427db5651c257da6970b.png" alt="" data-value="6">
            <img class="agreement" src="https://pic.xiaobaibao.com/clause/2022/11/76c2c8b74bb64649a9cbcb0ea8bbc910.png" alt="" data-value="7">
            <div></div>
          </div>
          <div class="confirmReading">
            <div class="confirm" @click="confirmReading"> 我已阅读并同意上述内容{{countdown}} </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 温馨提示弹窗 -->
    <el-dialog
      :visible.sync="warmPromptDialog"
      width="80%"
      :modal="true"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :show-close="false"
      class="warmPromptDialog"
      v-if="warmPromptDialog"
      center>
      <div class="head">
        <div class="title">穗岁康</div>
      </div>
      <div class="check">
        <div><b>温馨提示，你即将进入参保流程:</b></div>
        <div class="content">
          您将进入由广州市医疗保障局指导，中国人寿保险股份有限公司广东省分公司、平安养老保险股份有限公司广东分公司、中国人民财产保险股份有限公司、
          中国太平洋人寿保险股份有限公司四家商业保险公司联合承保的“穗岁康”参保/参保信息填写操作页面，请您仔细阅读并理解页面内容，并确保所填信息真实准确。
          根据相关要求，您在投保页面上的操作将被记录并保存，敬请知悉。
        </div>
      </div>
      <div class="footer">
        <button @click="understand">
          <span>我知道了</span>
        </button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  export default {
    name: "sskProductDetailPage",
    data() {
      return {
        planId: '1772',
        productId: '100459',
        ensureTypeId: '105',
        tips: 0,
        detailsClientHeight: [],
        topBackgroundClientHeight: 0,
        scrollSwitchState: true,
        scrollValues: 0,
        target: 0,
        countdown: ' (05s)',
        clickState: false,
        upState: false,
        eventLogToken: '',
        /* 手机验证弹窗 */
        claimDialog: false,
        account: '',
        rightsToken: '',
        saleToken: '',
        promptStates: 'none',
        errorPrompt: '',
        startTime: '',
        loginAccount: '',
        /* 阅读协议弹窗 */
        checked: false,
        checkedRead: false,
        readTimer: null,
        agreementContentHeight: [],
        forbidSlidingProtocolState: true,
        lineWidthList: [],
        /* 温馨提示 */
        warmPromptDialog: true,
      }
    },
    methods: {
      // 事件绑定
      eventBinding() {
        let that = this;

        //-- 切换主题
        $(".main-info .tit-item").on("click", function () {
          that.tips = parseInt($(this).attr("data-tips"));

          that.scrollSwitchState = false;
          that.clickState = true;
          that.scrollIntoDesignatedPlace();
        });

        //-- 查看保障详情
        $(".detailsList #detail-content1").on("click", function () {
          that.$router.push({name: "sskGuaranteeDetailPage", query: {}});
        });

        //-- 是否同意 -> 查看协议
        $(".whetherAgree>.checkbox").off().click(function(){
          that.chooseRead(0);
        });
      },

      // 我知道了 - 默认弹窗
      understand(){
        this.warmPromptDialog = false;
      },

      // 确认 - 已阅读阅读条款
      confirmReading(){
        let that = this;
        if (!that.checked) return;

        that.checked = true;
        that.checkedRead = false;
        $('body').removeClass('forbiddenScroll');
        that.countdown = ' (05s)';
      },

      // 打开 - 预览条款
      chooseRead(value = 0){
        let that = this;

        if (value == 0) value = 1;
        if (that.checked){
          that.checked = false;
          return;
        }

        that.checkedRead = true;
        $('body').addClass('forbiddenScroll');

        // 切换选中条款
        setTimeout(function(){
          that.$nextTick(() => {
            setTimeout(() => {
              // 计算 - 协议内容高度
              let height = 0;
              that.agreementContentHeight[0] = 0;
              for (let i = 1; i < 8; i++) {
                let selectTitleHeight = $(`.agreementContent img:nth-child(${i})`).height();
                height += Math.round(selectTitleHeight);
                that.agreementContentHeight[i] = height;
              }

              // 计算 - 协议标题宽度
              let tabUnitNum = $(`.tabList`).children('.tabUnit').length;
              for (let i = 0; i < tabUnitNum; i++) {
                let tabUnitWidth = $(`.tabList>div:nth-child(${i+1})`).width();
                that.lineWidthList[i] = tabUnitWidth;
              }

              that.handleAgreementContentScroll();
              that.tabUnit(value, false);
            })
          });

          // 监听页面滚动，切换协议弹窗导航栏定位
          document.addEventListener('scroll',that.handleAgreementContentScroll,true);
        }, 500);

        let seconds = 5;
        that.readTimer = setInterval(function(){
          seconds--;
          that.countdown = ` (0${seconds}s)`;

          if (seconds == 0) {
            that.countdown = '';
            that.checked = true;
            $(".confirmReading").css('background','#074f98');
            clearInterval(that.readTimer);
          }
        }, 1000);

      },

      // 关闭 - 预览条款
      closeDialog(){
        let that = this;

        that.checked = false;
        that.checkedRead = false;
        $('body').removeClass('forbiddenScroll');
        that.countdown = ' (05s)';
        clearInterval(that.readTimer);
      },

      // 切换 - 协议弹窗标题
      tabUnit(value, forbidSlidingProtocolState){
        let that = this;
        that.forbidSlidingProtocolState = forbidSlidingProtocolState;

        $(`.tabList>div:nth-child(${value})`).addClass("selectTab").siblings().removeClass("selectTab");
        $(`.agreementContent img:nth-child(${value})`).addClass('selectAgreement').siblings().removeClass('selectAgreement');

        let target = $(`.tabList>div:nth-child(${value})`),             // 当前元素
          halfScreenWidth = window.innerWidth/2,                      // 一半屏幕宽度
          ulWidth = $(".tabList").width(),                            // 主题宽度
          leftWidth = (target.width()/2) + target.get(0).offsetLeft,  // 点击元素中点距离屏幕左侧
          rightWidth = ulWidth - leftWidth,                           // 点击元素中点距离屏幕右侧
          width = target.width();

        if(leftWidth > halfScreenWidth){
          $(".tabList").animate({scrollLeft: leftWidth - halfScreenWidth}, 'speed'); // 滚动到中间
        }else if(rightWidth < halfScreenWidth){
          $(".tabList").animate({scrollLeft:(window.devicePixelRatio*window.innerWidth)-ulWidth}, 'speed'); // 滚动到末尾
        }else{
          $(".tabList").animate({scrollLeft: 0}, 'speed'); // 滚动到最前
        }

        // 滑动内容
        if (!forbidSlidingProtocolState){
          let scrollTop = document.getElementsByClassName("agreementContent")[0].scrollTop,
            imgOffsetTop = that.agreementContentHeight[value-1] + 1;
          $(".agreementContent").animate({scrollTop: imgOffsetTop}, 300);

          let scrollValue = 0;
          let timer = setInterval(function(){
            if (!that.checkedRead) clearInterval(timer);
            scrollTop = document.getElementsByClassName("agreementContent")[0].scrollTop;

            if (scrollValue != scrollTop){
              scrollValue = scrollTop;
            }else {
              that.forbidSlidingProtocolState = true;
              clearInterval(timer);
            }
          }, 100);
        }

        // 移动滑条
        let totalDistance = 0;
        for (let i in that.lineWidthList){
          if (parseInt(i)+1 == value) break;
          totalDistance += that.lineWidthList[i];
        }

        value = totalDistance + width/2 - 20;

        $(".tabList .line").css({
          '-webkit-transform': `translate(${value}px, 0)`,
          'transform': `translate(${value}px, 0)`,
        });
      },

      // 协议主题- 内容滚动计算
      handleAgreementContentScroll(){
        let that = this,
          scrollTop = document.getElementsByClassName("agreementContent")[0].scrollTop,
          value = parseInt($('.selectAgreement').attr('data-value'));

        if (scrollTop > that.agreementContentHeight[value] && that.forbidSlidingProtocolState){
          value++;
          contentAssign();
        }

        if (scrollTop < that.agreementContentHeight[value-1] && that.forbidSlidingProtocolState){
          value--;
          contentAssign();
        }

        function contentAssign() {
          that.tabUnit(value, true);
          $(`.agreementContent img:nth-child(${value})`).addClass('selectAgreement').siblings().removeClass('selectAgreement');
        }
      },

      // 产品主题切换
      scrollIntoDesignatedPlace(){
        let that = this,
          {tips} = that;

        $(`.main-info .tit-item:nth-child(${tips})`).addClass("active").siblings().removeClass("active");

        const transform = ["0", "25%", "50%", "75%"];
        $("#nav .line").css({
          '-webkit-transform': `translate(${transform[tips]}, 0)`,
          'transform': `translate(${transform[tips]}, 0)`
        });

        let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;

        // 滑动到指定位置
        if (that.clickState){
          let top = $(`#detail-content${parseInt(tips)+1}`).offset().top - 40;
          $("html,body").animate({scrollTop: top}, 'speed');

          let scrollValue = 0;
          let timer = setInterval(function(){
            scrollTop = document.body.scrollTop || document.documentElement.scrollTop;

            if (scrollValue != scrollTop){
              scrollValue = scrollTop;
            }else {
              that.scrollSwitchState = true;
              that.clickState = false;
              that.scrollValues = scrollTop;
              clearInterval(timer);
            }
          }, 100);
        }else {
          that.scrollSwitchState = true;
        }
      },

      // 产品主题- 内容滚动计算
      handleScroll() {
        let that = this;

        let scrollTop = document.body.scrollTop || document.documentElement.scrollTop,
          {topBackgroundClientHeight, tips} = that;

        // 页面向下滚动超过导航栏位置，导航栏定位顶部
        if (scrollTop > topBackgroundClientHeight-1){
          $('#nav').addClass('topPosition');
          that.upState = true;
        }else {
          if ($('#nav').hasClass('topPosition')) $('#nav').removeClass('topPosition');
          that.upState = false;
        }

        // 计算滚动位置，切换主题
        let contentScrollHeight = scrollTop - topBackgroundClientHeight;

        // 向下滚动超过当前主题 - 主题切换下一个
        if (contentScrollHeight > that.detailsClientHeight[that.tips] && that.tips < 3 && that.scrollSwitchState){
          that.tips++;
          that.scrollSwitchState = false;
          that.scrollIntoDesignatedPlace();
        }

        // 向上滚动超过当前主题 - 主题切换上一个
        if (that.tips > 0 && contentScrollHeight < that.detailsClientHeight[that.tips-1] && that.scrollSwitchState){
          that.tips--;
          that.scrollSwitchState = false;
          that.scrollIntoDesignatedPlace();
        }
      },

      //-- 立即领取权益
      getInterest(){
        let that = this;

        if (that.$$.isValidObj(that.rightsToken)){
          // -- 我已阅读
          if( !that.checked ) return that.chooseRead(0);

          that.$router.push({name: "sskInfoFillingPage", query: {rightsToken: that.rightsToken, eventLogToken: that.eventLogToken}});
        }else {
          that.claimDialog = true;
        }
      },

      //-- 手机号校验
      receiveCheck(){
        let that = this;
        const errorMsg = that.validationForm_phone(that.account);
        console.log(errorMsg);
        if(errorMsg != null) return that.errorPrompt = errorMsg;

        //-- 图形验证
        if (!that.$$.isValidObj(that.startTime)) {
          that.$$.geeTestInit(that);
        }
      },

      //-- 验证手机号
      validationForm_phone(account){
        if(!this.$$.isValidObj(account)) return "请输入手机号~";
        if(!this.$$.constant.phoneReg.test(account)) return "手机号格式错误，请重新输入！";

        return null;
      },

      //-- 权益登录手机校验
      phoneCheck(){
        let that = this;
        let loading = that.Loading.service({fullscreen: true});
        that.axios.post('/member/unicom/check', {phoneNum: that.account, saleToken: that.saleToken, startTime: that.startTime}).then((response) => {
          that.$nextTick(() => loading.close());
          let data = response.data;
          $('.contact').hide();
          that.promptStates = 'none';
          this.rightsToken = '';

          if (data.success) {
            const {rightsToken} = data.datas;
            that.rightsToken = rightsToken;
            that.claimDialog = false;
            that.$message.success('验证通过！');

            //-- 本地缓存 rightsToken
            that.$$.localStorageSet('interests_rightsToken'+that.saleToken, rightsToken, 5 * 60 * 1000);
            that.$$.localStorageSet('interests_loginAccount'+that.saleToken, that.account, 5 * 60 * 1000);
            that.loginAccount = this.account;
          }else {
            that.startTime = '';

            const {msg, code, rightsToken} = data;

            if (that.$$.isValidObj(code)){
              that.securityNumber = code;
              that.rightsToken = rightsToken;

              $('.contact').show();
            }else if (msg.includes('您的权益领取申请正在审核中,请耐心等待!')){
              $('.contact').show();
            }

            that.errorPrompt = msg;
          }
        });
      },

    },
    destroyed() {
      // 销毁监听
      document.removeEventListener('scroll', this.handleScroll,true);
      document.removeEventListener('scroll', this.handleAgreementContentScroll,true);
    },
    mounted() {
      let that = this;

      // 事件绑定
      that.eventBinding();

      // 获取主题高度
      that.$nextTick(() => {
        setTimeout(() => {
          let height = 0;
          that.detailsClientHeight[0] = 0;

          for (let i = 0; i < 4; i++) {
            let selectTitleHeight = $(`#detailsList #detail-content${i+1}`).height();
            height += selectTitleHeight;
            that.detailsClientHeight[i] = height;
          }

          // 顶部图片高度
          that.topBackgroundClientHeight = document.getElementsByClassName("topBackground")[0].clientHeight;
          that.handleScroll();
        }, 500);
      });

      // 监听页面滚动，切换导航栏定位
      document.addEventListener('scroll',that.handleScroll,true);

      that.saleToken = decodeURIComponent(encodeURIComponent(that.$route.query.saleToken).replace(new RegExp("%20","gm"),"%2B"));

      //-- 获取权益数据
      if (!that.$$.isValidObj(that.saleToken)) {
        that.$$.alert({
          message: '链接参数有误，请重新领取权益!',
          type: 'warning',
          onOk: function () {
            that.$router.go(-1);
          }
        });
      }

      that.account = that.$route.query.account;
      that.rightsToken = decodeURIComponent(encodeURIComponent(that.$route.query.rightsToken).replace(new RegExp("%20","gm"),"%2B"));

      if (that.$$.isValidObj(that.account) && that.$$.isValidObj(that.rightsToken)) {
        //-- 本地缓存 rightsToken
        that.$$.localStorageSet('interests_rightsToken'+that.saleToken, that.rightsToken, 5 * 60 * 1000);
        that.$$.localStorageSet('interests_loginAccount'+that.saleToken, that.account, 5 * 60 * 1000);
        that.loginAccount = this.account;
      }else {
        // 登录状态 - 本地缓存获取
        const rightsToken = that.$$.localStorageGet('interests_rightsToken'+that.saleToken);
        const loginAccount = that.$$.localStorageGet('interests_loginAccount'+that.saleToken);

        if (that.$$.isValidObj(rightsToken) && that.$$.isValidObj(loginAccount)) {
          that.rightsToken = rightsToken;
          that.loginAccount = loginAccount;
          that.claimDialog = false;
          that.$$.localStorageSet('interests_rightsToken'+that.saleToken, rightsToken, 5 * 60 * 1000);
          that.$$.localStorageSet('interests_loginAccount'+that.saleToken, loginAccount, 5 * 60 * 1000);
        }else {
          localStorage.removeItem('interests_rightsToken'+that.saleToken);
          localStorage.removeItem('interests_loginAccount'+that.saleToken);
        }
      }

      // 测试协议弹窗
      // that.chooseRead(0);

      // 产品屏幕录制
      let eventLogToken = decodeURIComponent(encodeURIComponent(that.$route.query.eventLogToken).replace(new RegExp("%20","gm"),"%2B"));
      if (that.$$.isValidObj(eventLogToken)) {
        that.screenRecBase.startLoad();
        that.eventLogToken = eventLogToken;
      }

    },
  }
</script>

<style scoped>
  @import "../../../../static/css/common.css";
  /**
 * 穗岁康-产品详情 css
 * @Author 吴成林
 * @Date 2022-10-24 16:00
 */

  #sskProductDetailPage {
    /*max-width: 750px;*/
    margin: 0 auto;
    padding-bottom: 10rem;
    position: relative;
    width: 100%;
    height: 100%;
    overflow: auto;
    background: #ffffff;
  }

  header{
    position: relative;
  }

  /* 标题切换 */
  #nav {
    width: 100%;
    height: 40px;
    margin: 0 auto;
    background: #f8fbfc;
    border-bottom: none;
    font-size: 1rem;
    z-index: 101;
  }

  .topPosition{
    /*max-width: 750px!important;*/
    position: fixed!important;
    top: 0!important;
    margin: 0 auto;
    left:0;
    right:0;
    bottom:0;
  }

  .info-tit {
    position: relative;
    width: 100%;
  }

  .info-tit:after {
    content: '';
    position: absolute;
    left: 50%;
    margin-left: -0.005rem;
    top: 0.135rem;
    display: block;
    width: 0.01rem;
    height: 0.14rem;
  }

  .tit-item {
    max-width: 25%;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    -webkit-tap-highlight-color: transparent!important;
  }

  .tit {
    width: 100%;
    text-align: center;
    color: #333;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0)!important;
    -webkit-user-select: none;
    -moz-user-select: none;
  }

  .main-info .tit-wrap {
    width: 100%;
    height: 26px;
    line-height: 26px;
    margin: 5px auto;
    border-right: 1px solid #ccc;
    font-size: 1.5rem;
  }
  .main-info .tit-item:nth-child(4) .tit-wrap{
    border-right: none;
  }

  .tit.active {
    color: #064f98;
  }

  .main-info .line{
    position: relative;
    width: 100%;
    -webkit-transition: -webkit-transform .5s;
    -o-transition: transform .5s;
    transition: transform .5s, -webkit-transform .5s;
    -webkit-transform: translate(0, 0);
    -ms-transform: translate(0, 0);
    transform: translate(0, 0);
  }
  .main-info .line .sliding{
    width: 25%;
  }
  .main-info .line .slidingBlock{
    border: 1px solid #064f98;
    background: #064f98;
    width: 40px;
    margin: 0 auto;
    text-align: center;
  }

  /* 内容 */
  .detailsListPosition{
    margin-top: 40px!important;
  }
  .blankBlock{
    height: 40px;
    width: 100%;
    background: #FFFFFF;
  }
  #detailsList{
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    width: 100%;
  }
  #detailsList>div{
    /*margin-top: 5px;*/
    /*border-bottom: 1px solid red;*/
  }

  /*#detail-content1{
    position: relative;
    max-height: 550px;
    padding-top: 72%;
    background: url("../../../../static/images/product/ssk/details-1.png") no-repeat center / cover;
  }

  #detail-content2{
    max-height: 3866px;
    padding-top: 515%;
    background: url("../../../../static/images/product/ssk/details-2.png") no-repeat center / cover;
  }

  #detail-content3{
    max-height: 2676px;
    padding-top: 357%;
    background: url("../../../../static/images/product/ssk/details-3.png") no-repeat center / cover;
  }

  #detail-content4{
    max-height: 2076px;
    padding-top: 277%;
    background: url("../../../../static/images/product/ssk/details-4.png") no-repeat center / cover;
  }

  #detail-content5{
    max-height: 446px;
    padding-top: 59%;
    background: url("../../../../static/images/product/ssk/details-5.png") no-repeat center / cover;
  }*/

  /* 底部 */
  footer{
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 101;
    background: #ffffff;
    width: 100%;
  }
  .footerUnit{
    /*max-width: 750px;*/
    margin: 0 auto;
    text-align: center;
    height: 5rem;
    display: flex;
  }
  .kefu{
    padding: 0 1.6rem;
    height: 100%;
    margin: 0 auto;
    text-align: center;
  }
  .kefuImg{
    width: 3rem;
    max-height: 3rem;
    padding-top: 100%;
    background: url("../../../../static/images/product/ssk/kefu.png") no-repeat center / cover;
  }
  .kefuText{
    text-align: center;
    font-size: 1.33rem;
    line-height: 2rem;
  }
  .submit{
    flex: 1;
    background: #064f98;
    color: #ffffff;
    font-size: 1.5rem;
    line-height: 5rem;
  }

  /* 手机验证 弹窗 */
  .el-dialog__wrapper /deep/ .el-dialog{
    margin-top: 30vh!important;
    border-radius: 15px;
    position: relative;
  }

  .el-dialog__wrapper /deep/ .el-dialog__title{
    color: #FA6E50;
    font-size: 16px;
    font-weight: bold;
  }
  .el-dialog__wrapper /deep/ .el-dialog__body{
    padding: 0px!important;
    width: 100%;
    text-align: center;
    position: absolute;
    border-radius: 15px;
    top: 0;
    left: 0;
    background: #ffffff;
  }
  .el-dialog__wrapper /deep/ .el-dialog__headerbtn{
    z-index: 999;
    font-size: 2.5rem;
    top: 10px;
    right: 15px;
  }

  .head{
    width: 100%;
    line-height: 30px;
    border-radius: 15px 15px 0 0;
    padding: 15px 0;
    font-weight: bold;
    background: url("../../../../static/images/product/dialogBg-1.png") no-repeat center / cover;
    letter-spacing: 1px;
  }
  .head .title{
    color: #064f98;
    font-size: 16px;
  }
  .head .title-hint{
    color: #333333;
    font-size: 14px;
    text-align: center;
  }

  .check{
    padding: 20px 10%;
    background: #FFFFFF;
    border-radius: 0 0 15px 15px;
  }
  .account /deep/ .el-input__inner{
    text-align: center;
  }
  .receive{
    margin: 15px auto 10px;
  }

  .claim .getInterest>button,
  .receive{
    width: 100%;
    height: 40px;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background: #FFBA5F;
    border-radius: 4px;
    border: none;
    clear: both;
  }

  .cueWords{
    display: block;
  }
  .prompt{
    display: flex;
    justify-content: center;
    text-align: center;
  }
  .prompt>span:first-child{
    display: inline-block;
    width: 18px;
    height: 18px;
    margin: 2px 2px 0 0;
  }

  .prompt .errorPrompt{
    max-width: calc(100% - 30px);
    color: #FA6E50;
    font-size: 14px;
    font-weight: bold;
  }
  .prompt .errorPrompt /deep/ a{
    display: inline-block;
    text-decoration: underline;
    color: #1a73e8;
  }

  .contact{
    font-size: 12px;
    color: #999999;
    margin: 20px auto 5px;
    display: none;
  }
  .contact a{
    color: #B98C65;
    display: inline-block;
  }

  /* 阅读协议 */
  .clause{
    height: 5rem;
    padding: 2vw 2vw;
    color: #666;
    margin: 0 auto;
    justify-content: left;
    align-items: center;
  }
  .clause .clauseUnit{
    color: #074f98;
    font-size: 1.2rem;
  }
  .clause .whetherAgree{
    margin: 0 1.5vw 0 1vw;
  }
  .clause .whetherAgree>img{
    width: 1.5rem;
    height: 1.5rem;
  }

  /* 阅读协议弹窗 */
  .readDialog{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    z-index: 999;
    background: #ffffff;
    text-align: center;
    overflow: hidden;
  }

  .readDialogView{
    /*max-width: 750px;*/
    margin: 0 auto;
    text-align: center;
    position: relative;
  }

  .readDialog-header{
    font-weight: 500;
    font-size: 4vw;
    line-height: 12vw;
    text-align: center;
  }

  .readDialog-header .closeDialog {
    line-height: inherit;
    position: absolute;
    top: 12px;
    right: 30px;
    width: 2px;
    height: 22px;
    background: #c8c9cc;
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    display: inline-block;
  }
  .closeDialog:after {
    line-height: inherit;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    width: 2px;
    height: 22px;
    background: #c8c9cc;
    -webkit-transform: rotate(270deg);
    -moz-transform: rotate(270deg);
    -o-transform: rotate(270deg);
    -ms-transform: rotate(270deg);
    transform: rotate(270deg);
  }

  .tabList{
    line-height: 10vw;
    width: 100%;
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    display: flex;
    padding: 0 2.133vw 0 2.133vw;
    position: relative;
  }
  .tabList::-webkit-scrollbar,
  .agreementContent::-webkit-scrollbar {
    display: none;
  }

  .tabList .tabUnit{
    font-size: 4vw;
  }

  .tabList .selectTab{
    color: #074f98;
  }

  .tabList .line{
    display: block;
    padding-left: 2.133vw;
    position: absolute;
    top: 8.5vw;
    left: 0;
    /*width: 100%;*/
    -webkit-transition: -webkit-transform .5s;
    -o-transition: transform .5s;
    transition: transform .5s, -webkit-transform .5s;
    -webkit-transform: translate(0, 0);
    -ms-transform: translate(0, 0);
    transform: translate(0, 0);
  }
  .tabList .line .sliding{
    width: 25%;
  }
  .tabList .line .slidingBlock{
    border: 1px solid #064f98;
    width: 40px;
    margin: 0 auto;
    text-align: center;
  }

  /* 协议 - 弹窗内容 */
  .agreementContent{
    height: calc(100vh - 22vw);
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 12vw;
  }

  .agreementContent>img{
    border-bottom: 1px solid #cccccc;
  }

  .confirmReading{
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 1001;
    width: 100%;
    height: 12vw;
    line-height: 12vw;
    background-color: rgba(7, 79, 152, .4);
    color: #ffffff;
    font-size: 4.267vw;
  }

  /* 温馨提示弹窗 */
  .warmPromptDialog /deep/ .el-dialog{
    margin-top: 0!important;
    border-radius: 15px;
    position: absolute;
    top: 25%;
    left: 50%;
    transform: translate(-50%, -25%);
  }

  .warmPromptDialog /deep/ .el-dialog__title{
    color: #FA6E50;
    font-size: 16px;
    font-weight: bold;
  }
  .warmPromptDialog /deep/ .el-dialog__body{
    padding: 0px!important;
    width: 100%;
    text-align: center;
    position: absolute;
    border-radius: 15px;
    top: 0;
    left: 0;
    background: #ffffff;
  }
  .warmPromptDialog /deep/ .el-dialog__headerbtn{
    z-index: 999;
    font-size: 2.5rem;
    top: 10px;
    right: 15px;
  }

  .warmPromptDialog .head{
    line-height: 3rem;
    font-weight: bold;
    background: #f5f1f1;
    border-radius: 15px 15px 0 0;
  }

  .warmPromptDialog .check{
    padding: 1.5rem;
    line-height: 2.2rem;
    text-align: left;
  }
  .warmPromptDialog .check .content{
    color: #666666;
    padding-top: 10px;
  }
  .warmPromptDialog .footer{
    padding: 1rem 3rem 2rem;
  }
  .warmPromptDialog .footer button{
    color: white;
    background: linear-gradient(159deg, rgb(122, 175, 229) 0%, rgb(7, 79, 152) 100%);
    border: 0;
    border-radius: 2rem;
    width: 100%;
    height: 4rem;
    font-size: 1.5rem;
    position: relative;
    display: inline-block;
    text-align: center;
    cursor: pointer;
    -webkit-transition: opacity .2s;
    transition: opacity .2s;
    -webkit-appearance: none;
  }

  /* 公共 */
  .flex {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
  }
  a{
    display: inline;
    width: auto;
    text-decoration: none;
  }

  .none{
    display: none!important;
  }



</style>



// WEBPACK FOOTER //
// src/components/product/ssk/productDetailPage.vue